module.exports = __webpack_public_path__ + "okticon.51cc1de00c0b9b83a649.ttf";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/~/@okta/okta-signin-widget/dist/font/okticon.ttf
// module id = ../../../../@okta/okta-signin-widget/dist/font/okticon.ttf
// module chunks = 11